import { requestGet, requestPost, requestPut, requestDelete } from '../request'
import apiPath from './apiPath'

const api = {
  CreateSaleMenuSchedule(payload) {
    return requestPost(apiPath.SALE_MENU_SCHEDULE.path, payload)
  },

  GetOneSaleMenuSchedule(saleMenuScheduleID) {
    return requestGet(
      `${apiPath.SALE_MENU_SCHEDULE.path}/${saleMenuScheduleID}`
    )
  },

  GetAllSaleMenuSchedule(paging, sorting, filtering) {
    return requestGet(apiPath.SALE_MENU_SCHEDULE.path, {
      page: paging.page,
      size: paging.size,
      sortBy: sorting.byField,
      sortDir: sorting.isDesc ? 'asc' : 'desc',
      f_outletCode: filtering.outletCode,
      f_menuItemCode: filtering.menuItemCode,
      f_status: filtering.status,
      f_beginDate: filtering.beginDate,
      f_endDate: filtering.endDate,
      f_beginDay: filtering.beginDay,
      f_endDay: filtering.endDay,
      f_beginHour: filtering.beginHour,
      f_endHour: filtering.endHour
    })
  },

  UpdateSaleMenuSchedule(saleMenuScheduleID, payload) {
    return requestPut(
      `${apiPath.SALE_MENU_SCHEDULE.path}/${saleMenuScheduleID}`,
      payload
    )
  },

  DeleteSaleMenuSchedule(saleMenuScheduleID) {
    return requestDelete(
      `${apiPath.SALE_MENU_SCHEDULE.path}/${saleMenuScheduleID}`
    )
  }
}

export default api
